// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class ExtCardReplaceCardResultModel {
    static getAttributeTypeMap() {
        return ExtCardReplaceCardResultModel.attributeTypeMap;
    }
}
ExtCardReplaceCardResultModel.discriminator = undefined;
ExtCardReplaceCardResultModel.additionalProperties = false;
ExtCardReplaceCardResultModel.attributeTypeMap = [
    {
        "name": "memberNumber",
        "baseName": "memberNumber",
        "type": "string"
    },
    {
        "name": "orderReferenceNumber",
        "baseName": "orderReferenceNumber",
        "type": "string"
    },
];
//# sourceMappingURL=extCardReplaceCardResultModel.js.map